
import { mdiArrowLeft } from '@mdi/js'
export default {
  props: {
    isSpreadTextCustomizationDialogShowing: Boolean,
    steps: Array,
  },
  data() {
    return {
      stepper: false,
      mdiArrowLeft,
    }
  },
  methods: {
    closeAndCancelCustomization(){
      this.$emit('closeAndCancelCustomization')
    },
    close() {
      this.$emit('closeSpreadTextCustomizationDialog')
    },
    showCustomization() {
      this.stepper = true
    },
    closeCustomization() {
      this.stepper = false
    },
    saveCustomization() {
      this.$emit('saveCustomization')
      this.closeCustomization()
      this.close()
    },
  },
}
